export default "__VITE_ASSET__Cy2z8O17__"